import { render, staticRenderFns } from "./ContinueRegistrationModal.vue?vue&type=template&id=45a12747&scoped=true"
import script from "./ContinueRegistrationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContinueRegistrationModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ContinueRegistrationModal.vue?vue&type=style&index=0&id=45a12747&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a12747",
  null
  
)

export default component.exports